import { makeAutoObservable } from 'mobx';
import { RegisterValidationError } from '../../../../../infrastructure/types/features/auth/auth-types';
import {
  valid,
  validate,
} from '../../../../../../shared/logic/core-logic/validation/ValidationResult';
import { validationHelpers } from '../../../../../../shared/infrastructure/validation-rules/validation-helpers';
import { RegisterManager } from '../managers/RegisterManager';

class RegisterValidator {
  constructor(private registerManager: RegisterManager) {
    makeAutoObservable(this, {});
  }

  get phone() {
    const value = this.registerManager.phone;

    return validate(
      validationHelpers.notUndefinedOrNull(value) &&
        validationHelpers.notEmptyString(value as string),
      RegisterValidationError.PHONE_EMPTY,
    ).addCheckIfPreviousPassed(
      validationHelpers.phoneCorrectFormat(value as PhoneNumber),
      RegisterValidationError.PHONE_INCORRECT,
    );
  }

  get fio() {
    const value = this.registerManager.fio;

    return validate(
      validationHelpers.notUndefinedOrNull(value) &&
        validationHelpers.notEmptyString(value as string),
      RegisterValidationError.FIO_EMPTY,
    );
  }

  get login() {
    const value = this.registerManager.login;

    return validate(
      validationHelpers.notUndefinedOrNull(value) &&
        validationHelpers.notEmptyString(value as string),
      RegisterValidationError.EMAIL_EMPTY,
    ).addCheckIfPreviousPassed(
      validationHelpers.emailCorrectFormat(value),
      RegisterValidationError.EMAIL_INCORRECT,
    );
  }

  get password() {
    const value = this.registerManager.password;

    return validate(
      validationHelpers.notUndefinedOrNull(value) &&
        validationHelpers.notEmptyString(value as string),
      RegisterValidationError.PASSWORD_EMPTY,
    ).addCheckIfPreviousPassed(
      (value?.length || 0) >= 6,
      RegisterValidationError.PASSWORD_INCORRECT,
    );
  }

  get captcha() {
    const value = this.registerManager.smartCaptchaToken;

    return validate(
      validationHelpers.notUndefinedOrNull(value) &&
        validationHelpers.notEmptyString(value as SmartCaptchaToken),
      RegisterValidationError.CAPTCHA_NOT_ENDED,
    );
  }

  get hasErrors() {
    return this.fio.hasErrors || this.login.hasErrors || this.password.hasErrors;
  }

  get hasPhoneEnterErrors() {
    return this.phone.hasErrors || this.captcha.hasErrors;
  }
}

export { RegisterValidator };
